
import React, { useRef }from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { AgGridReact as AgGridReactType } from 'ag-grid-react';
import '@process-advisor/process-miner/shared/gridStyles.css'
import { type ColDef, themeAlpine } from 'ag-grid-community';

const Wrapper = styled.div<{ height: string }>`
    height: ${({ height }) => height};
    width: 600px;
    margin-top: 10px;
    margin-bottom: 5px;
`;

type SingleRow = {
    id: number;
    [key: string]: any
}

type Props = {
    rows: SingleRow[];
    height: string;
}

const discoveryRuleColumnsDef = () => [
    {
        field: 'type',
        headerName: 'Type',
        width: '150px'
    },
    {
        field: 'description',
        headerName: 'Description',
        flex: 1
    },
];

export const DataGrid: React.FC<Props> = ({
    rows,
    height
}) => {

    const grid = useRef<AgGridReactType>(null);
    const getRowHeight = () => 25;
   
    return (
        <Wrapper height={height}>
            <div
                style={{
                    width: '450px',
                    height: '100%',
                    fontSize: '12px',
                    fontFamily: 'system-ui'
,
                }}>
                <AgGridReact 
                    theme={themeAlpine} 
                    getRowHeight={getRowHeight}
                    ref={grid}
                    headerHeight={40}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        resizable: true,
                        wrapText: true,
                        autoHeight: true,
                    }}
                    rowData={rows}
                    columnDefs={discoveryRuleColumnsDef}
                    animateRows={true}
                />
            </div>
        </Wrapper>
    );
};

